import * as React from 'react';
import { Dialog, DialogActions, DialogBody, showCustom } from './controls/Dialog';
import { ConnectionCheckListener } from 'core/infrastructure';
import { Ellipsis } from './controls';
import { Res } from 'core/api';


interface Props {
	actions?: DialogActions<void>;
}

let currentDialog: Nullable<RetryConnectionDialog> = null;

class RetryConnectionDialog extends React.Component<Props> {
	public nextAction: 'abort' | 'retry' = 'retry';

	private timerId: Nullable<NodeJS.Timeout> = null;
	private startMs = +new Date();

	componentDidMount(): void {
		currentDialog = this;
		this.timerId = setInterval(() => this.forceUpdate(), 1000);
	}

	componentWillUnmount(): void {
		currentDialog = null;
		if (this.timerId)
			clearInterval(this.timerId);
	}

	close() {
		this.props.actions?.closeWith();
	}

	render() {
		const ellapsedMs = +new Date() - this.startMs;

		return <Dialog kind={'base'}>
			<DialogBody>
				<div>
					<span className='text-uppercase'>{Res.Msg.MSG_CONNECTING_TO_SERVER()}</span>
					<small className='text-muted m-l-xs'>{Math.floor(ellapsedMs / 1000)}s</small>
				</div>
				<div className='text-center'>
					<Ellipsis />
				</div>
				<div className='text-right text-12 text-uppercase'>
					<a className='link' onClick={() => this.nextAction = 'abort'}>
						<span className='text-danger'>{Res.Common.CANCEL_BTN()}</span>
					</a>
				</div>
			</DialogBody>
		</Dialog>;
	}

	public static show() {
		if (currentDialog)
			throw Error('Cannot stack RetryConnectionDialogs');

		void showCustom(<RetryConnectionDialog />);
	}
}

export const connectionCheckListener: ConnectionCheckListener = {
	onCheckCompleted: () => currentDialog?.close(),
	onConnectionFailed: async () => {
		if (currentDialog)
			return currentDialog.nextAction;

		// Si no se está mostrando un diálogo, lo muestro y reintento mientras
		RetryConnectionDialog.show();

		// Espero a que se muestre para evitar reentradas en este método. No puedo
		// hacer un await del show porque bloquea hasta que se cierra el diálogo,
		// y yo sólo quiero esperar hasta que aparezca, momento en que guardará su
		// propia referencia en currentDialog
		const check = (resolve: (value: 'retry' | 'abort') => void) => {
			if (currentDialog) {
				resolve(currentDialog.nextAction);
			}
			else {
				setTimeout(() => check(resolve), 10);
			}
		};

		return new Promise(resolve => {
			check(resolve);
		});
	}
};
